var reloadSideBarAjaxXHR = null;
var startSideBarUpdateTime;


function refreshSideBar(tourId) {

    if (reloadSideBarAjaxXHR) {
        reloadSideBarAjaxXHR.abort();
    }

    startSideBarUpdateTime = new Date();
    reloadSideBarAjaxXHR = loadSideBarData(tourId);

    reloadSideBarAjaxXHR.done(updateSideBarHtml);

    reloadSideBarAjaxXHR.done(stopTimerForFinished);
}

var timer = null;

function startSideBarTimer(tourId) {
    timer = setInterval(function() {
        refreshSideBar(tourId);
    }, 10000);
}

function stopSideBarTimer() {
    if (timer) {
        clearInterval(timer);
    }
}

function loadSideBarData(tourId) {
    return $.ajax({
        url: '/tourObject/sidebar/' + tourId,
        type: 'get',
        dataType: 'json'
    });
}

function updateSideBarHtml(data) {
    var $bidButton = $('#make-bet-button');
    var $formMessage = $('#make-bid-form-message');
    var $form = $('#make-bet-form');
    $('.price-js').replaceWith(data.currentPriceHtml);
    $('#bet-amount-label').html(data.nextBet.formatMoney(0, ' ', '.'));

    if ($('#bet_amount:focus').length == 0 && parseInt($('#bet_amount').val()) < parseInt(data.nextBet)) {
        $('#bet_amount').val(data.nextBet);
        $bidButton.attr('disabled', false);
        $form.attr('data-is-leader', data.isLeader);
        if (!$formMessage.hasClass('hidden')) {
            $formMessage.addClass('hidden');
        }
    }

    $('.make-bet-form').data('next-bet', data.nextBet);
    $('.make-bet-form').data('is-leader', data.isLeader);
    $('.make-bet-form').data('error-code', data.errorCode);
    $('.make-bet-form').data('error-confirm-text', data.errorConfirmText);
    $('.make-bet-form').data('error-confirm-url', data.errorConfirmUrl);
    $('.make-bet-form').data('error-message', $('<div/>').html(data.errorMessage).text());
    $('.make-bet-form').data('need-post', data.needPost);
    $('.make-bet-form').data('current-price', data.currentPrice);
    $form.attr('data-user-balance', data.userBalance);

    var bets = $(data.bets);
    var open = $('.hidden_bet:hidden').length == 0;
    var link_title = open ? 'Показать меньше' : 'Показать все ставки';
    if (open) {
        $('.hidden_bet', bets).show();
    }
    $('.load-more', bets).html(link_title);
    $('.bets-js').replaceWith(bets);

    if (data.finished) {
        $('.auction-js').replaceWith(data.finished);
    }

    $('.countdown').attr('class', '').addClass('countdown countdown-inline mt0').addClass('priority-' + data.priority);

    if (data.isExpress || data.isCeytnot) {
        if ($('.countdown').data('countdown') != data.endTrade) {

            $('.countdown').data('countdown', data.endTrade);
            initCountdown(data.datetime, startSideBarUpdateTime);

            $('.blitz-price-js').replaceWith(data.blitzPriceHtml);
            initPriceContdown(data.serverTime, data.blitzPrice);
        }
    }

    $('.limit-button-js').replaceWith(data.limitButtonHtml);

//    if(data.canBet) {
//        $bidButton.removeClass('disabled');
//    }

    if (data.isLeader) {
        if ($bidButton.attr('data-target') == '#bet-confirm-modal') {
            $bidButton.attr('data-target', '#bet-failure-modal');
        }
    } else if(data.needLogin){
      $bidButton.attr('data-target', '#bid-requirements-modal');

      $('#bid-requirements-modal .step-wizard-content').removeClass('active');
      $('#step-login').addClass('active');
      $('.step-wizard-step').removeClass('complete').removeClass('active');
      $('.step-wizard-step').eq(0).removeClass('complete').addClass('active');

    } else if(data.needPost && data.needJoinGroup){
      $bidButton.attr('data-target', '#bid-requirements-modal');

      if($('.step-wizard-step').length == 4){
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('complete').addClass('active');
        $('.step-wizard-step').eq(2).removeClass('complete').removeClass('active');
        $('.step-wizard-step').eq(3).removeClass('complete').removeClass('active');
        $('#step-join-group').addClass('active');
      }else{
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('complete').addClass('active');
        $('.step-wizard-step').eq(2).removeClass('active');
        $('#step-social-post').addClass('active');
      }
    }else if(data.needPost){
      if($('.step-wizard-step').length == 4){
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(2).removeClass('complete').addClass('active');
        $('.step-wizard-step').eq(3).removeClass('active');
        $('#step-social-post').addClass('active');
      }else{
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('complete').addClass('active');
        $('.step-wizard-step').eq(2).removeClass('active');
        $('#step-social-post').addClass('active');
      }
    }else {
      $bidButton.attr('data-target', '#bet-confirm-modal');
      if($('.step-wizard-step').length == 4){
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('#step-bid-confirm').addClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(2).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(3).addClass('active');

      }else{
        $('#bid-requirements-modal .step-wizard-content').removeClass('active');
        $('.step-wizard-step').eq(0).removeClass('active').addClass('complete');
        $('.step-wizard-step').eq(1).removeClass('complete').removeClass('active');
        $('.step-wizard-step').eq(2).addClass('active');
        $('#step-bid-confirm').addClass('active');
      }
    }

    $(document).trigger('sidebar.htmlUpdated');
}

function stopTimerForFinished(data) {
    if (data.isFinished) {
        stopSideBarTimer();
    }
}

function initCountdown(serverTime, loadTime) {
    $('.countdown').countdown({
        serverTime: serverTime,
        showOnZeroDays: false,
        loadTime: loadTime,
        zeroCallback: function(options) {
//            if(sleep) {
                window.setTimeout(function() {
                    window.location.reload();
                }, 300);
//            } else {
//                window.location.reload();
//            }
        }
    });
}

// Функция подключения слушателей вступления в группу
function listenForGroupJoin(callback) {
    var fbStay = setInterval(function() {
      if (typeof(FB) != 'undefined' && FB != null ) {
        clearInterval(fbStay);
        FB.Event.subscribe('edge.create', function() {
            callback();
        });
      }
    }, 500);

    if (typeof(VK) != 'undefined' && VK != null) {
      VK.Observer.subscribe("widgets.groups.joined", function f() {
          callback();
      });
    }

    function listenForOkJoin() {
      if (window.addEventListener) {
        window.addEventListener('message', onJoin, false);
      } else {
        window.attachEvent('onmessage', onJoin);
      }
    }
    function onJoin(e) {
      var args = e.data.split("$");
      if (args[0] == "ok_join") {
          callback();
      }
    }
    listenForOkJoin();
}

// Функция проверки баланса пользователя
function checkBalance(tour_id, user_id, callback) {
    // $.post('/tourObject/checkBalance?tour_id=' + tour_id + '&user_id=' + user_id, {}, function(response) {
    //     if (response.success) {
    //         // Должен поплнить
    //         // var $modal = $('#user-balance-modal');
    //         // $modal.modal('show');
    //         reachGoal('zapros_balans')
    //     } else {
    //         // Все ок, может делать ставку
    //         callback();
    //     }
    // }, 'json');
}

var initStepContent = function () {
    var $wizard = $('#get-tour-access-wizard');
    var $activeStepContent = $wizard.find('.step-wizard-content.active');

    if ($activeStepContent.attr('id') == 'step-login') {
        reachGoal('zapr_reg');
    }

    if ($activeStepContent.attr('id') == 'step-join-group') {
        var okGroupId = $('#ok-group-modal').attr('data-groupid');
        var vkGroupId = $('#vk-group-modal').attr('data-groupId');
        reachGoal('zapr_group');

        var map = {
            ok: {
                id: 'ok-group-modal',
                groupId: okGroupId,
                options: "{width:320,height:400}"
            },
            vk: {
                id: 'vk-group-modal',
                groupId: vkGroupId,
                options: {mode: 0, width: 'auto', height: '400'}
            },
            fb: {
                id: 'fb-group-modal'
            }
        };

        // init groups after small timeout
        setTimeout(function () {
            initSocialGroups(map, function () {
                // vertical center modal after social group is shown
                $('#bid-requirements-modal').css('margin-top', ($('#bid-requirements-modal').outerHeight() / 2) * -1);
            });
        }, 400);
    }

    if ($activeStepContent.attr('id') == 'step-social-post') {
        var $button = $('#make-post-button');
        $button.primeButtonLoading(true);

        $.ajax({
            url: '/tourObject/createUrl',
            data: {
                json: true,
                share_type: 'bet',
                id: $button.attr('data-tourid'),
                bet: null // Цена
            },
            dataType: 'json',
            success: function(response) {
                $button.primeButtonLoading(false);
                if (response.error == 1) {
                    var $failureModal = $('#bet-failure-modal');
                    $failureModal.find('.message').html(response.error_message);
                    $failureModal.modal('show');

                    return;
                }

                $button.data('post-data', response);
            },
            error: function(data) {
                $button.primeButtonLoading(false);
                var $failureModal = $('#bet-failure-modal');
                $failureModal.find('.message').html('Произошла ошибка, попробуйте еще раз');
                $failureModal.modal('show');
            }
        });
    }

    if ($activeStepContent.attr('id') == 'step-bid-confirm') {
        var currentBid = parseInt($('#bet_amount').val());
        $activeStepContent.find('#current-step-bid').html(currentBid.formatMoney(0, ' ', '.'));
    }
};

function checkInputMinBid() {
    var minBid = parseInt($('#make-bet-form').attr('data-next-bet'));
    var $message = $('#make-bid-form-message');
    var currentBid = parseInt($('#bet_amount').val());
    var $button = $('#make-bet-button');
    if (currentBid < minBid) {
        $message.removeClass('hidden');
        $button.addClass('disabled');
        $button.attr('disabled', true);
    } else {
        $message.addClass('hidden');
        $button.removeClass('disabled');
        $button.attr('disabled', false);
    }
};

function beginMakeBet(){
  var $this = $('#make-bet-button');
  var $form = $this.parents('form');
  if ($form.attr('data-need-post')) {
    reachGoal('first_bet_zapr');
  }
  $.post('/tourObject/logTryMakeBet', {
    tour_id: $form.data('id')
  });

  var errorCode = $form.data('error-code');


  if(errorCode != ''){
    var confirmButtonText = $form.data('error-confirm-text') ? $form.data('error-confirm-text') : "Ок";
    var confirmButtonUrl = $form.data('error-confirm-url') ? $form.data('error-confirm-url') : "";
    var closeOnConfirm = confirmButtonUrl ? false : true;
    var showCancelButton = confirmButtonUrl ? true: false;
    var cancelButtonText = 'Отмена';

    setTimeout(function(){
      swal({
        html: true,
        title: errorCode,
        text: $form.data('error-message'),
        type: "error",
        closeOnCancel: true,
        showCancelButton: showCancelButton,
        cancelButtonText: cancelButtonText,
        confirmButtonColor: "#2A8FBD",
        confirmButtonText: confirmButtonText,
        closeOnConfirm: closeOnConfirm
      },function(){
          if(confirmButtonUrl){
            location.href = confirmButtonUrl;
          }
        }
      );
    },500);
  }else{
    $($this.attr('data-target')).modal();
  }
}

$(function () {
    var $bidRequirementsModal = $('#bid-requirements-modal');
    var $userBalanceModal = $('#user-balance-modal');

    // $bidRequirementsModal.on('show', function () {
    //     $(this).find('.step-wizard').trigger('step-shown-step-wizard');
    // });
    //

    // Различные действия перед тем как загружается каждый шаг требований.
    // Подключение групп
    // Создание ссылки для расшаривания в соцсети
    $('#get-tour-access-wizard').on('step-shown-step-wizard', initStepContent);
    $bidRequirementsModal.on('show', initStepContent);

    // Ставим куку, чтобы автоматом сделать ставку после логина
    $('#bid-requirements-modal .auth-service a.btn').on('click', function () {
        $.cookie('autoMakeBid', true, {
            expires: 1,
            path: '/'
        });
    });


    // пытаемся сделать ставку после авторизации
    if ($.cookie('autoMakeBid') && !$.cookie('friendsCountNotify')) {
        $.removeCookie('autoMakeBid', { path: '/' });
//        $('#make-bet-button').trigger('click');
        beginMakeBet($('#make-bet-button'));
    }

    // Снова пытаемся сделать ставку после удачной оплаты
    if ($.cookie('payment')) {
        $.removeCookie('payment', { path: '/' });
        $('#make-bet-button').trigger('click');
    }

    $('#balance-next-button').on('click', function () {
        $('#balance-message').addClass('hidden');
        $('#balance-form').removeClass('hidden');

        $('#balance-next-button-container').addClass('hidden');
        $('#charge-button-container').removeClass('hidden');

        setTimeout(function () {
            $userBalanceModal.css('margin-top', ($userBalanceModal.outerHeight() / 2) * -1);
        },20);
    });

    $('#user-balance-modal').on('click', '#chargeButton', function (e) {
        e.preventDefault();

        $.cookie('payment', false, {
            expires: 1,
            path: '/'
        });
    });

    // Пропускаем шаги во всплывашке, если нужно
    // $bidRequirementsModal.on('shown', function () {
    //     var $wizard = $('#get-tour-access-wizard');
    //     var $activeStepContent = $wizard.find('.step-wizard-content.active');
    //     if ($activeStepContent.attr('id') == 'step-join-group' || $activeStepContent.attr('id') == 'step-social-post') {
    //         $('.step-wizard').trigger('step-shown-step-wizard');
    //     }
    // });

    // Пытаемся слушать события вступления в группу когда открыта всплывашка
    listenForGroupJoin(function () {
        reachGoal('ok_group');
        if ($bidRequirementsModal.is(':visible')) {
            $('#get-tour-access-wizard').trigger('show-next-step-wizard');
        }
    });

    // Обновление текущей ставки в модальном окне подтверждения ставки
    // Слушайтся именно show а не show.bs.modal из-за https://github.com/jschr/bootstrap-modal/issues/228
    $('#bet-confirm-modal').on('show', function () {
        var currentBid = parseInt($('#bet_amount').val());
        var needBalance = currentBid * 0.1;
        $(this).find('#current-modal-bet').html(currentBid.formatMoney(0, ' ', '.'));
        $(this).find('#required-balance').html(needBalance.formatMoney(0, ' ', '.'));

        if (currentBid > 500) {
            $(this).find('.required-balance-message').removeClass('hidden');
        }
    });

    // Обновление текущей ставки в модальном окне пополнения баланса
    // Слушайтся именно show а не show.bs.modal из-за https://github.com/jschr/bootstrap-modal/issues/228
    $userBalanceModal.on('show', function () {
        var currentBid = parseInt($('#bet_amount').val());
        var needBalance = currentBid * 0.1;
        $(this).find('#user-balance-modal-required-balance').html(needBalance.formatMoney(0, ' ', '.'));

        if (needBalance < 100) {
            needBalance = 100;
        }

        if (currentBid > 500) {
            $(this).find('.required-balance-message').removeClass('hidden');
        }
    });

    // Обработчик кнопки "сделать пост"
    $('#make-post-button').on('click', function (e) {
        e.preventDefault();
        reachGoal('click_post');
        $button = $(this);
        $button.primeButtonLoading(true);

        var postData = $button.data('post-data');

        // Актуально для поста вк с мобильного. Ставим куку чтобы снова запустить механизм ставки
        $.cookie('autoMakeBid', true, {
            expires: 1,
            path: '/'
        });
        postData.success = function () {
            // $bidRequirementsModal.modal('hide');
            $button.primeButtonLoading(false);
            reachGoal('post_new');
            // $('#bet-confirm-modal').find('.additional-message').html('<h3 class="text-center">Отлично!<br>теперь вы можете приступить к торгам</h3>');
            // $('#bet-confirm-modal').modal('show');
            $('#get-tour-access-wizard').trigger('show-next-step-wizard');
            $('#make-bet-form').find('button:submit').attr('data-target', '#bet-confirm-modal');

            // удаляем куку автоставки
            $.removeCookie('autoMakeBid', { path: '/' });
        };

        postData.error = function () {
            $('#bet-failure-modal').find('.message').html('Чтобы начать торги, разместите пост о лоте.');
            $('#bet-failure-modal').modal('show');
            $button.primeButtonLoading(false);

            // удаляем куку автоставки. А может и не удаляем. Из-за печальной особенности хрома под мобилой.
            // после того как вспылвающее окно загрузилось с другим доменом, оно почему-то считается закрытым
            // $.removeCookie('autoMakeBid', { path: '/' });
        };

        socialPost(postData, $button.attr('data-service'));
    });

    // На всякий случай всегда очищаем дополнительное сообщение в окне подтверждения ставки
    $('#bet-confirm-modal').on('hidden', function () {
        $(this).find('.additional-message').html('');
    });

    // Обработчик кнопки подтверждения ставки
    $('.bid-confirm-button').on('click', function () {
        var $form = $('.make-bet-form');
        $form.submit();
        $('#bet-confirm-modal').modal('hide');
        if ($bidRequirementsModal.is(':visible')) {
            $bidRequirementsModal.modal('hide');
        }
    });

    //кнопка ставки
    $('#make-bet-button').on('click', function(e){
      e.preventDefault();

      beginMakeBet();

      return false;
    });


    // Форма ставки
    $('#make-bet-form').on('submit', function (e) {
        e.preventDefault();
        var $submitButton = $(this).find('button:submit');
        var $form = $(this);
        var needPost = $(this).attr('data-need-post');

        var userBalance = $form.attr('data-user-balance');
        var currentBid = parseInt($('#bet_amount').val());

        if (currentBid > 500) {
            reachGoal('zapros_bet_500');
            var needBalance = currentBid * .1;
            if (userBalance - needBalance < 0) {
                reachGoal('zapros_balans');
                $userBalanceModal.modal('show');
                return;
            }
        }


        $submitButton.primeButtonLoading(true);
        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serialize(),
            success: function (response) {
                $submitButton.primeButtonLoading(false);

                if (!response.success) {
                    var $failureModal = $('#bet-failure-modal');
                    $failureModal.find('.message').html(response.error_message);
                    $failureModal.modal('show');

                    return;
                }

                if (response.isFirstUserBet) {
                    reachGoal('first_bet_ok');
                }

                if (parseInt(response.current_price.replace(' ', '')) > 500) {
                    reachGoal('bet_500');
                }

                var $successModal = $('#bet-success-modal');
                $successModal.modal('show');
                refreshSideBar($('#tour-sidebar').data('tour-id'));
            }
        });
    });

    var betAmountTimer;

    $('#bet_amount').on('keyup', function () {
        if (betAmountTimer) {
            clearTimeout(betAmountTimer);
        }
        betAmountTimer = setTimeout(function () {
            checkInputMinBid();
        }, 300);
    });

    $(document).on('sidebar.htmlUpdated', function(){
      $('.complaint-tooltip').tooltip();
    })

  if($('.complaint-tooltip').length > 0){
    $('.complaint-tooltip').tooltip();
    $('#tour-sidebar').on('click', 'a.complaint-tooltip', function(e){
      e.preventDefault();

      $('#complaint-modal #Complaint_to_user_id').val($(this).data('user-id'));
      $('#complaint-modal #complaint_to_user_name').text($(this).data('user-name'));

      if($(this).data('is-guest')=='1'){
        $('#login-modal').modal();
      }else{
        $('#complaint-modal').modal().on('hidden.bs.modal', function(){
          $('textarea','#complaint-modal form')
            .not(':button, :submit, :reset, [type=hidden]')
            .val('');
          $('input[type=radio]')
            .removeAttr('checked')
            .removeAttr('selected');
          $('#reason-text').hide();

          $('#complaint-modal form').find('input[type=radio]').iCheck('update');
          $('#complaint-modal .alert').remove();
        });
      }

      return false;
    });
  }

  $('#complaint-modal').on('ifChanged', 'input', function(){
    if($(this).is(':checked')){
      if('прочее' == $(this).val()){
        $('#reason-text').show();
        $('#reason-text textarea').focus();
      }else{
        $('#reason-text').hide();
      }
    }
  });

  $('#complaint-modal').on('click', '.btn-primary', function(e){
    e.preventDefault();

    $('#complaint-modal form').submit();

    return false;
  });

  $('#complaint-modal').on('submit', 'form', function(e){
    e.preventDefault();
    $('#complaint-modal .alert').remove();

    $.ajax({
      url: $(this).attr('action'),
      type: 'post',
      dataType: 'json',
      data: $(this).serialize(),
      success: function(json){
        if(json.result == 'error'){
          $('#complaint-modal .post-preview > .row').append(json.errors);
        }else if(json.result == 'success'){
          $('#complaint-modal').modal('hide').on('hidden.bs.modal', function(){
            swal({
              title: 'Отправлено',
              text: 'Ваша жалоба будет рассмотрена.',
              type: "success",
              confirmButtonColor: "#2A8FBD",
              confirmButtonText: "Ок",
              closeOnConfirm: true
            });
          });
        }
      }
    });

    return false;
  });

    $('.specials-box').owlCarousel({
        navigation : false, // Show next and prev buttons
        slideSpeed : 300,
        paginationSpeed : 400,
        singleItem:true,
        autoPlay: 5000
    });

    $('#tour-validate-phone-button').on('click', function (e) {
        e.preventDefault();
        var phone = $('#phone-input').val();
        var $button = $(this);
        if (phone) {
            $button.primeButtonLoading(true);
            $.ajax({
                url: '/notification/sendValidationCode',
                data: {
                    phone: phone
                },
                success: function (response) {
                    $button.primeButtonLoading(false);
                    if (response.success) {
                        $('#phone-row').fadeOut(300);
                        $('#code-row').fadeIn(300).removeClass('hidden');
                    } else {
                        alert(response.error);
                    }
                }
            });
        }
    });

    $('#tour-validate-code-button').on('click', function (e) {
        e.preventDefault();
        var code = $('#phone-code-input').val();
        var $button = $(this);
        if (code) {
            $button.primeButtonLoading(true);

            $.ajax({
                method: 'post',
                data: {
                    code: code
                },
                url: '/notification/validateCode',
                success: function (response) {
                    $button.primeButtonLoading(false);
                    if (response.success) {
                        $('#code-row').fadeOut(300);
                        $('#success-row').fadeIn(300).removeClass('hidden');
                        $('#disable-ask-phone-row').addClass('hidden');
                        $('#close-success-modal').prop('disabled', false).removeClass('disabled');
                        $('#bet-success-modal').on('hide', function () {
                            location.reload();
                        });
                    } else {
                        alert(response.error);
                    }
                }
            });
        }
    });

    $('#disable-ask-phone-after-bet').on('change', function (e) {
        e.preventDefault();
        var checked =$(this).is(':checked');
        if (checked) {
            $('#close-success-modal').removeClass('disabled').prop('disabled', false);
        } else {
            $('#close-success-modal').addClass('disabled').prop('disabled', true);
        }

        $.ajax({
            url: '/notification/disableAskPhone',
            data: {
                disable: !!checked
            }
        });
    });
});
